function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const ButtonContainer = styled.div`
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
`;
const StyledIcon = styled(FontAwesomeIcon)`
  margin-left: 1rem;
  cursor: pointer;
`;

class ToggleActionFormButtonContainer extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(ButtonContainer, null, this.props.children, /*#__PURE__*/React.createElement(StyledIcon, {
        icon: faTimes,
        onClick: this.props.closeForm
      }));
    });
  }

}

export default ToggleActionFormButtonContainer;